import utils from '@bigcommerce/stencil-utils';
import itemInCart from './card-item-in-cart';
import openSlideCart from '../common/open-slide-cart';
import { fireAddToCart } from '../custom/event/ga4-events';
import { getMotherShipSku } from '../custom/event/productSkuMap';

export default function () {
    let prevFocus = false;
    const $slideCart = $("#cart-preview-dropdown");

    function updateSideCart() {
        const $sideCart = $('.side-cart-content');
        const $sideCartDetails = $('.side-cart-details');
        const $sideCartActions = $('.side-cart-actions');

        const options = {
            template: {
                template: 'f/b2b/side-cart-content',
                details: 'f/b2b/side-cart-details',
                actions: 'f/b2b/side-cart-actions',
                itemcount: 'f/cart/item-count',
            },
        };

        utils.api.cart.getContent(options, (err, response) => {
            if (response.itemcount > 0) {
                //console.log("getContent response form: ",response);
                $sideCart.html(response.template);
                $sideCartDetails.html(response.details);
                $sideCartActions.html(response.actions);
                $('.cart-quantity').html(response.itemcount);
                itemInCart();
            }

            $('.side-cart-loading').css('display', 'none');
            $('.side-cart-item').css('opacity', '1');
        });
    }

    // Popup function for input notification
    function popup(target, str, delay) {
        const $addPopup = $(target).find('.add-card-popup');

        $addPopup.html(`${str}`);
        $addPopup.fadeIn(0).delay(delay).fadeOut(0);
        $('target').blur();
    }

    function addProductToCart(event, form) {
        document.prevFocus = ( document.activeElement || document.body );
        $('.side-cart-loading').css('display', 'block');
        $('.side-cart-item').css('opacity', '0.5');

        // Get target product
        const $addToCartBtn = $('.button.button--primary.button--cardAdd', $(event.target));
        const originalBtnVal = $addToCartBtn.val();
        const waitMessage = $addToCartBtn.data('waitMessage');

        // Do not do AJAX if browser doesn't support FormData
        if (window.FormData === undefined) {
            $('.side-cart-loading').css('display', 'none');
            $('.side-cart-item').css('opacity', '1');
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const input = form.querySelector('input[type="submit"][value="Add to Cart"]');
        if(input){
            const formElement = input.parentElement;
            if(formElement){
                const quantityElement = formElement.querySelector('input[type="tel"][name="qty[]"]');
                let quantityValue = 1;
                if(quantityElement){
                    quantityValue = quantityElement.value;
                }
                //getAddToCartData(input.dataset.productId,quantityValue);
            }
        }

        $addToCartBtn
            .val(waitMessage)
            .prop('disabled', true);

        // Add item to cart
        utils.api.cart.itemAdd(new FormData(form), (err, response) => {
            const errorMessage = err || response.data.error;
            let failure = false;
            getAddToCartData(response);

            // GA4 add_to_cart — fire for listing page card adds.
            // Enrich with line_items data so category_names (and brand, pricing) reach the mapper;
            // response.data.cart_item alone lacks those fields.
            if (response.data?.cart_item) {
                const cartData = response.data;
                const lineItem = (cartData.line_items || [])
                    .find(li => li.product_id === cartData.cart_item?.product_id)
                    || cartData.line_items?.[0]
                    || {};
                const enrichedCartItem = {
                    ...cartData.cart_item,
                    name:           lineItem.product_name || cartData.cart_item.name || '',
                    product_sku:    getMotherShipSku(cartData.cart_item?.product_id) || lineItem.sku || cartData.cart_item.sku || '',
                    sku:            lineItem.sku || cartData.cart_item.sku || '',
                    sale_price:     lineItem.sale_price ?? cartData.cart_item.sale_price
                                        ?? cartData.cart_item.price_ex_tax
                                        ?? cartData.product_value ?? 0,
                    base_price:     lineItem.base_price ?? null,
                    retail_price:   lineItem.retail_price ?? null,
                    purchase_price: lineItem.purchase_price ?? null,
                    quantity:       lineItem.quantity ?? cartData.cart_item.quantity ?? 1,
                    discount:       lineItem.discount ?? 0,
                    brand_name:     lineItem.brand_name || '',
                    category_names: lineItem.category_names || [],
                    variant_id:     lineItem.variant_id ?? null,
                    currency:       lineItem.currency || cartData.currency || 'USD',
                    price:          lineItem.purchase_price ?? 0,
                };
                fireAddToCart(enrichedCartItem, enrichedCartItem.currency);
            }

            $addToCartBtn
                .val(originalBtnVal)
                .prop('disabled', false);

            // Guard statement
            if (errorMessage) {
                failure = true;
                popup(event.target, errorMessage, 4000);
            } else {
                // To add lang string
                popup(event.target, 'Item added', 2000);
            }

            const cartOptions = {
                template: 'f/cart/item-count',
            };

            utils.api.cart.getContent(cartOptions, (error, resp) => {
                $('.cart-quantity').html(resp);
                if (utils.tools.storage.localStorageAvailable()) {
                    localStorage.setItem('cart-quantity', resp);
                }
            });

            if ( !failure ) {
                
                updateSideCart();
                console.log("Opening slide cart from card-add-to-cart.js");
                openSlideCart();
            }
        });
    }

    $('[data-cart-item-add-from-card]').on('submit', (event) => {
        addProductToCart(event, event.target);
    });
}
